import { Box, Typography, IconButton, Button } from "@mui/material";
import {
  NotificationsOutlined
} from "@mui/icons-material";
import NavTabs from "../ui-atoms/NavTabs";
import { ReactNode, useContext, useState } from "react";
import Notifications from "../notifications/Notifications";
import { AreliaBadge } from "../ui-atoms/Badge";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { CustomPalette } from "../../theme/palette";
import { useNotifications } from "../../api/notifications";
import AppContext from "../../AppContext";
import { Roles } from "../../types";
import { ChatSlideout } from "@arelia-components/chatgpt/ChatSlideout";
import { useConfiguration } from "src/api/configuration";
import { PATHS } from "src/routes";
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';

export type HeaderProps = {
  title: ReactNode;
  action?: ReactNode;
  navOptions?: {
    value: string;
    label: string;
    externalLink?: boolean;
  }[];
  navValue?: string;
  setNavValue?: (navValue: string) => void;
  dashboard?: boolean;
  backTo?: {
    label: string;
    path: string;
  }
};

export default function Header({
  title,
  navOptions,
  navValue,
  setNavValue,
  dashboard = false,
  backTo,
  action
}: HeaderProps) {
  const [notificationsDrawerOpened, setNotificationsDrawerOpened] = useState(false);
  const { data: notifications } = useNotifications();
  const { account, selectHqIsActive } = useContext(AppContext);
  const { data: config } = useConfiguration();

  const navigate = useNavigate();

  const goBack = () => () => navigate(backTo?.path as string);

  const toggleDrawer =
    () =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        if (
          event &&
          event.type === 'keydown' &&
          ((event as React.KeyboardEvent).key === 'Tab' ||
            (event as React.KeyboardEvent).key === 'Shift')
        ) {
          return;
        }

        setNotificationsDrawerOpened(true);
      };

  return (
    <Box sx={{ zIndex: 2, position: "relative" }}>
      <Box display="flex" mb={dashboard ? 8 : 2}>
        <Box ml="auto" display="flex" gap={2}>
          {
            account?.role === Roles.Admin && <> {
              selectHqIsActive
                ? <Link to={PATHS.DASHBOARD}>
                  <Button sx={{ height: "100%" }} variant="contained" color="primary">MY DASHBOARD</Button>
                </Link>
                : <Link to={PATHS.HQ_DASHBOARD}>
                  <Button sx={{ height: "100%" }} variant="contained" color="success">HQ HOME</Button>
                </Link>
            } </>
          }

          <a href="https://areliatech.com/arelia-university" target="_blank" rel="noopener noreferrer">
            <IconButton color="secondary">
              <ContactSupportOutlinedIcon />
            </IconButton>
          </a>

          {config?.flags.EnableAIChat && <ChatSlideout />}

          <IconButton color="secondary" onClick={toggleDrawer()}>
            <AreliaBadge badgeContent={notifications?.filter(n => !n.isRead).length} color="error">
              <NotificationsOutlined />
            </AreliaBadge>
          </IconButton>

          {/* <ArelTooltip title={"Coming Soon..."}>
            <span>
              <Fab
                size="small"
                sx={{ bgcolor: "common.white", transform: "rotate(90deg)", pointerEvents: "none" }}
              >
                <TuneOutlined />
              </Fab>
            </span>
          </ArelTooltip> */}
        </Box>
      </Box>
      <Box
        borderBottom={dashboard ? 0 : 1}
        borderColor="#e2e2e2"
        pb={1}
        display="flex"
        justifyContent="center"
        alignItems="flex-start"
        flexDirection="column"
      >
        {
          backTo
            ? <Typography variant="subtitle1" sx={{
              color: dashboard ? "#fff" : CustomPalette.secondary.main,
              display: "flex",
              alignItems: "center",
              cursor: "pointer"
            }} onClick={goBack()}>
              <ArrowBackIcon sx={{ marginRight: "10px" }} />
              {backTo?.label}
            </Typography>
            : <></>
        }
        <Box
          display="flex"
          alignItems="center"
          width="100%"
        >
          <Typography
            variant="h1"
            sx={{
              color: dashboard ? "#F7F8FA" : "#000",
              marginRight: navOptions ? "50px" : "0",
              width: navOptions ? "auto" : "100%",
            }}
          >
            {title}
          </Typography>
          {navOptions && navValue && setNavValue && navOptions.length > 0 &&
            <NavTabs
              options={navOptions}
              value={navValue}
              setValue={setNavValue}
            />
          }
          {action}
        </Box>
      </Box>
      <Notifications
        open={notificationsDrawerOpened}
        onClose={() => setNotificationsDrawerOpened(false)}
        onOpen={() => setNotificationsDrawerOpened(true)}
      />
    </Box>
  );
}
